/**
 * ClipboardMixin - Reusable clipboard functionality for Vue components
 * 
 * Provides copy-to-clipboard functionality with:
 * - Hover state management
 * - Success state feedback with checkmark icons
 * - German language support
 * - Browser compatibility detection
 * - Error handling
 */
export default {
  data() {
    return {
      copyIconHover: { 
        name: false, 
        address: false, 
        email: false, 
        phone: false, 
        birthdate: false, 
        svnr: false 
      },
      copySuccessState: { 
        name: false, 
        address: false, 
        email: false, 
        phone: false, 
        birthdate: false, 
        svnr: false 
      },
      copyTimeouts: {}
    };
  },

  computed: {
    isClipboardSupported() {
      return navigator.clipboard && navigator.clipboard.writeText;
    }
  },

  beforeDestroy() {
    // Clear all pending timeouts to prevent memory leaks
    Object.values(this.copyTimeouts).forEach(timeoutId => {
      clearTimeout(timeoutId);
    });
    this.copyTimeouts = {};
  },

  methods: {
    async copyToClipboard(value, fieldName) {
      if (!value || !this.isClipboardSupported) {
        this.$emit('showError', { 
          message: 'Kopieren wird von diesem Browser nicht unterstützt.',
          timeout: 8000
        });
        return;
      }

      try {
        await navigator.clipboard.writeText(value);
        this.handleCopySuccess(fieldName);
      } catch (error) {
        this.handleCopyError(error, fieldName);
      }
    },

    handleCopySuccess(fieldName) {
      // Map field names to German labels
      const fieldLabels = {
        'name': 'Name',
        'address': 'Adresse',
        'email': 'E-Mail Adresse',
        'phone': 'Telefonnummer',
        'birthdate': 'Geburtsdatum', 
        'svnr': 'SV-Nr'
      };
      
      const fieldLabel = fieldLabels[fieldName] || 'Daten';
          
      this.$emit('showInfo', { 
        message: `${fieldLabel} erfolgreich in die Zwischenablage kopiert.`,
        timeout: 5000
      });
      
      // Show success state with checkmark icon
      this.$set(this.copySuccessState, fieldName, true);
      
      // Clear any existing timeout for this field
      if (this.copyTimeouts[fieldName]) {
        clearTimeout(this.copyTimeouts[fieldName]);
      }
      
      // Set new timeout and store reference
      this.copyTimeouts[fieldName] = setTimeout(() => {
        this.$set(this.copySuccessState, fieldName, false);
        delete this.copyTimeouts[fieldName];
      }, 1500);
    },

    handleCopyError(error, fieldName) {
      this.$emit('showError', { 
        message: 'Kopieren fehlgeschlagen. Bitte versuche es erneut.',
        timeout: 8000,
        error: error
      });
    },

    setCopyIconHover(fieldName, isHovering) {
      this.$set(this.copyIconHover, fieldName, isHovering);
    }
  }
};